export default class GiftConfig {

  constructor() {
      this.campaignId = '0';
      this.minPercentageMaintenanceTax = 0;
      this.maxPercentageMaintenanceTax = 0;
      this.minPercentageExpected = 0;
      this.maxPercentageDesired = 0;
  }
}